import { useParams } from 'react-router-dom'
import useLang from '@/utils/hooks/use-lang'
import FullScreenBanner from '@/components/full-screen-banner'
import PageWrapper from '@/components/page-wrapper'
import { i18nSolutionCustom } from '@/assets/content/solution'
import { SolutionGreenPowerPlantProps } from '@/assets/content/solution/green-power-plant'
import { Flex } from 'antd'
import ScrollGallery from '@/components/scroll-gallery'
import ImageText from '../new-items/image-text'
import FeatureIcons from '../new-items/feature-icons'
import Styles from './style.module.scss'

export default function GreenCity() {
  const { type } = useParams()
  const [lang] = useLang()

  const content: SolutionGreenPowerPlantProps = i18nSolutionCustom?.[lang].find(
    ({ path }) => path === `/solution/${type}`
  )

  const { banner, title, description, featureIcons, imageText, applications } = content || {}
  
  return (
    <PageWrapper soul>
      <FullScreenBanner image={banner} className={Styles.bannerWrapper} vertical>
        <div className={Styles.content}>
          {!!title && <h1>{title}</h1>}
          {/* {!!description && <div className={Styles.description}>{description}</div>} */}
        </div>
      </FullScreenBanner>
      <Flex vertical className={Styles.contentWrapper}>
        {!!featureIcons?.length && <FeatureIcons data={featureIcons} />}
        {!!imageText?.length && <ImageText data={imageText} />}
      </Flex>
      {!!applications?.length && (
        <div className={Styles.applicationWrapper}>
          <h2>Application</h2>
          <ScrollGallery
            cards={applications}
            renderCard={({ title, description, image }) => (
              <Flex
                vertical
                justify='flex-end'
                key={title}
                className={Styles.applicationItem}
                style={{ background: `url(${image}) no-repeat center / cover` }}
              >
                <div className={Styles.applicationLabel}>{title}</div>
                <div className={Styles.applicationDescription}>{description}</div>
              </Flex>
            )}
          />
        </div>
      )}
    </PageWrapper>
  )
}
